import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state to show the fallback UI
    return { hasError: true };
  }

  

  render() {
    if (this.state.hasError) {
      // Render a custom fallback UI
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
